import { useAppSelector } from "../redux";

/**
 * Custom hook that returns the effective organization for the current user.
 * For admin users who have selected a different organization, returns the selected organization.
 * For regular users or admins who haven't selected a different organization, returns the user's default organization.
 */
export const useEffectiveOrganization = () => {
  const user = useAppSelector((state) => state.session.user);
  const selectedOrganizationId = useAppSelector((state) => state.session.selectedOrganizationId);

  // Determine the effective organization ID
  const effectiveOrganizationId = user?.isAdmin && selectedOrganizationId ? selectedOrganizationId : user?.organizationId;

  // Get the organization object
  const organization = useAppSelector((state) => {
    if (effectiveOrganizationId) {
      return state.organization.entities[effectiveOrganizationId] || null;
    }
    return null;
  });

  return {
    /** The effective organization object */
    organization,
    /** The effective organization ID */
    organizationId: effectiveOrganizationId,
    /** Whether the user is an admin using a selected organization (different from their default) */
    isUsingSelectedOrg: user?.isAdmin && !!selectedOrganizationId && selectedOrganizationId !== user?.organizationId,
  };
};
